import {
  FETCH_PVS_KEYWORD_REQUEST,
  FETCH_PVS_KEYWORD_SUCCESS,
  FETCH_PVS_KEYWORD_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchPvsKeywordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PVS_KEYWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case FETCH_PVS_KEYWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Keywords fetched successfully",
      };

    case FETCH_PVS_KEYWORD_FAILURE:
      return {  
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message,
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchPvsKeywordReducer;
